var _style, _text, _defs, _defs2, _defs3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDhoorbin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{font-family:'ArialMT';}\r\n\t.st1{font-size:12px;}\r\n\t.st2{fill:url(#SVGID_00000049932297945318708960000015150595829067090337_);}\r\n\t.st3{fill:url(#SVGID_00000013912031904925673440000016118188924589874879_);}\r\n\t.st4{fill:url(#SVGID_00000029768468654309981460000011769592130249361798_);}\r\n\t.st5{fill:url(#SVGID_00000025437250488789024290000013558402282979901617_);}\r\n\t.st6{fill:url(#SVGID_00000119082851802467667860000011859440372429036470_);}\r\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st0 st1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "1,1 2,1 1,2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140014375038532414470000003865873755475567541_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000172436934234812348990000008972468211212779142_",
    points: "1,1 2,1 1,2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104671089269093202320000000434735567662703535_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172436934234812348990000008972468211212779142_",
    style: {
      overflow: "visible"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000006696387932289056970000013126698537634116230_",
    points: "1,1 2,1 1,2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093145824182960708300000017271707974510103215_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006696387932289056970000013126698537634116230_",
    style: {
      overflow: "visible"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057121796630225307900000008260546418621276571_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.0401,
    y1: 6412.75,
    x2: 297.8251,
    y2: 6412.75,
    gradientTransform: "matrix(1 0 0 -1 0 6505.6665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E3192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEEF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057121796630225307900000008260546418621276571_)"
    },
    d: "M297.8,89.9c-15.1,1.1-24.9,4.9-34.1,17.5 c-5.5-13-12.9-23.9-26.6-29c7.7,1.1,15.5,2.1,22.1,6.4c2.5,1.7,4.7,3.9,7.1,5.6c0.8,0.6,1.9,0.8,3,0.6 C278.5,86.4,287.8,87.4,297.8,89.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066505108808165174420000007328895067073453980_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.7883,
    y1: 6356.9497,
    x2: 378.7883,
    y2: 6023.2627,
    gradientTransform: "matrix(1 0 0 -1 0 6505.6665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E3192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEEF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066505108808165174420000007328895067073453980_)"
    },
    d: "M393.4,244.7 c-37.7-7.3-74.3,17.4-81.6,55.2c-3.3,17.1-0.1,34.9,9.1,49.7c-8.9-37.7,14.4-75.4,52.1-84.3c28.3-6.7,57.7,4.8,74.1,28.9 C442,273.3,423.1,250.5,393.4,244.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098905339521608066470000015057328112551042742_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.7445,
    y1: 6356.9497,
    x2: 130.7445,
    y2: 6023.2627,
    gradientTransform: "matrix(1 0 0 -1 0 6505.6665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E3192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEEF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098905339521608066470000015057328112551042742_)"
    },
    d: "M145.4,244.7 c-37.7-7.3-74.3,17.5-81.6,55.2c-3.3,17.1-0.1,34.8,9.1,49.7c-8.9-37.7,14.5-75.4,52.2-84.3c28.2-6.7,57.6,4.8,74,28.8 C192.1,268.7,171.2,249.5,145.4,244.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104706720497658221240000014451184372466476724_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.0864,
    y1: 6491.2324,
    x2: 256.0864,
    y2: 5990.4312,
    gradientTransform: "matrix(1 0 0 -1 0 6505.6665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E3192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEEF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104706720497658221240000014451184372466476724_)"
    },
    d: "M478.3,262.6 c-6.2-12.6-14.8-23.7-25.4-32.8l-19-13.9c-35.7-26-71.4-52.1-107.1-78.1l0,0c-2.9-2.6-6.1-4.6-9.7-6.1l-0.8-0.5l0,0 c-6.4-2.5-13.5-1.6-19,2.5L235,179l0,0c-5.9,4.3-11.8,8.6-17.8,13c-5.9,4.3-11.1,8.4-16.7,12.7l-0.4-0.5l48.2-44.2 c-10.5-8.1-20.5-15.8-30.6-23.6c-10.5-8.1-19.3-8.4-30.1-0.6c-31.1,22.7-62.3,45.4-93.4,68.3l-28,20.4l0,0l-0.8,0.6 c-13.4,10.5-24.4,23.6-32.4,38.7C16.8,298,17,332.3,34.7,366.9c7.2,14.1,17.6,26.2,30.3,35.6c24.1,18.8,54.9,26.6,84.9,21.6 c33-5,58.7-21.9,77.2-49.8c3-4.6,6.8-8.7,11.1-12.1c15-11.6,32.9-8.1,44.3,8.6c9.2,13.4,19.2,25.5,32.6,34.7 c25.4,17.4,53.6,23.8,83.8,17.9c41.1-7.9,69.7-31.8,84.6-70.8C495.4,321.9,492.9,291.7,478.3,262.6z M133.6,401.1 c-22.8,0.2-44.6-8.6-60.9-24.4c-10-9.3-16.6-21.1-22.7-33.1c-4.9-21.4-6.6-42.7,2.5-63.6c4.5-10.6,11-20.3,19.2-28.4 c34.3-33.9,89.6-33.5,123.4,0.8c16.1,16.3,25.1,38.2,25.2,61.1C220.2,361.9,181.2,401.3,133.6,401.1z M378.9,401.1 c-48.2,0-87.3-39-87.4-87.2c0-48.2,39-87.3,87.2-87.3s87.3,39,87.4,87.2C466.2,361.9,427.2,401.1,378.9,401.1L378.9,401.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106847452193382350620000001430010755920583589_",
    gradientUnits: "userSpaceOnUse",
    x1: 850,
    y1: -415.7058,
    x2: 850,
    y2: 254.4787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E3192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEEF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 543.8,
    y: -225.7,
    style: {
      fill: "url(#SVGID_00000106847452193382350620000001430010755920583589_)"
    },
    width: 612.4,
    height: 213.3
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhoorbin);
export default __webpack_public_path__ + "static/media/dhoorbin.905fd5df88bbbc830ccdbefd950b41eb.svg";
export { ForwardRef as ReactComponent };